// Fonctionnalités présentées sur la page d'accueil (chaînes en français = clés de traduction).
export type FeatureVisualId = 'site' | 'guests' | 'rsvp' | 'events' | 'seating' | 'budget' | 'retro' | 'dashboard' | 'dayplan';

export interface Feature {
  visual: FeatureVisualId; // petite animation en tête de carte
  title: string;
  text: string;
  points: string[];
  soon?: boolean;
}

export const FEATURES: Feature[] = [
  {
    visual: 'site',
    title: 'Un site d’invitation qui vous ressemble',
    text: 'Une jolie page à votre nom, à partager par lien ou QR code. Vos invités adorent, et vous n’avez rien à coder.',
    points: [
      'Votre couleur, vos polices et votre photo',
      'Adresse personnalisée vous.please-rsvp.com',
      'QR code à imprimer sur le faire-part',
    ],
  },
  {
    visual: 'guests',
    title: 'Une liste d’invités toujours à jour',
    text: 'Adieu « invites_final_v7.xlsx » : familles, groupes et enfants sont rangés, et chaque réponse s’y inscrit toute seule.',
    points: [
      'Import de votre liste existante',
      'Groupes (famille, amis…) et enfants',
      'Filtres, recherche et export en un clic',
    ],
  },
  {
    visual: 'rsvp',
    title: 'Toutes les réponses, sans rien recopier',
    text: 'Vos invités répondent en quelques secondes, pour toute leur famille. Vous recevez tout, déjà trié.',
    points: [
      'Présence événement par événement',
      'Choix du menu, allergies, musique, questions libres',
      'Réponse pour toute la famille, email à chaque réponse',
    ],
  },
  {
    visual: 'events',
    title: 'Un mariage, plusieurs moments',
    text: 'Cérémonie, cocktail, dîner, brunch : chacun ses invités, ses options et ses compteurs.',
    points: [
      'Invitations différentes selon les événements',
      'Options à choisir (ex. menus)',
      'Compteurs de présents par événement',
    ],
  },
  {
    visual: 'seating',
    title: 'Un plan de table sans prise de tête',
    text: 'Posez vos tables, glissez vos invités : seuls ceux qui viennent sont à placer, et le traiteur a ses menus table par table.',
    points: [
      'Tables rondes ou rectangulaires',
      'Vue traiteur avec menus et allergies',
      'Impression du plan',
    ],
  },
  {
    visual: 'budget',
    title: 'Un budget sous contrôle',
    text: 'Trois questions et votre budget est réparti poste par poste. Ensuite, chaque dépense et chaque échéance est suivie pour vous.',
    points: [
      'Payé, engagé et reste à payer, poste par poste',
      'Échéancier : acompte, solde, paiement en plusieurs fois',
      'Rappel par email avant chaque échéance',
    ],
  },
  {
    visual: 'retro',
    title: 'Un rétroplanning qui vous guide',
    text: 'Quoi faire, et quand : un planning calé sur votre date, à votre rythme. Vous ne pensez plus à rien, on vous le rappelle.',
    points: [
      'Vue d’ensemble, équilibré ou pas à pas',
      'Tâches à cocher, déplacer ou ajouter',
      'Rappel par email à chaque nouvelle étape',
    ],
  },
  {
    visual: 'dashboard',
    title: 'Votre mariage en un coup d’œil',
    text: 'Compte à rebours, réponses, budget, prochaines tâches : vous savez toujours où vous en êtes.',
    points: [
      'Compte à rebours jusqu’au jour J',
      'Réponses, budget et plan de table',
      'Prochaines tâches, paiements et réponses',
    ],
  },
  {
    visual: 'dayplan',
    title: 'Déroulé du jour J',
    text: 'La journée heure par heure, partagée avec vos témoins et vos prestataires : plus personne ne vous demande « on fait quoi, là ? ».',
    points: [
      'Qui fait quoi, et une heure qui se décale en un clic',
      'Un lien pour l’équipe, sans compte à créer',
      'Le programme affiché sur votre site',
    ],
  },
];
